import { getLang } from 'mailup-react-helpers'
import { createIntl, createIntlCache, type IntlShape } from 'react-intl'

import messages from '../i18n/messages.json'

let intlInstance: IntlShape | null = null

type JsonKeys = keyof typeof messages

/**
 * @returns standalone intl utility
 *
 */
const getIntl = (): IntlShape => {
  if (intlInstance === null) {
    const l: JsonKeys = getLang()
    const cache = createIntlCache()

    intlInstance = createIntl({ messages: messages[l], locale: l }, cache)
  }
  return intlInstance
}

export default getIntl
